export default __webpack_public_path__ + "static/media/E08.96f6b827.mp3";